import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import PointsPerPassengerList from '../../../../components/bookingResume/pointsPerPassengerList/PointsPerPassengerList';

import './PaymentInformations.css';

const I18n = require('i18n-react').default;

const propTypes = {
    passengers: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          lastName: PropTypes.string,
          suffix: PropTypes.string,
          passengerType: PropTypes.string
        })
    ).isRequired,
    departureFlight: PropTypes.shape({
        originAirport: PropTypes.string,
        finalDestination: PropTypes.string,
        category: PropTypes.string,
        prices: PropTypes.arrayOf(
          PropTypes.shape({
            category: PropTypes.string,
            passenger: PropTypes.string,
            value: PropTypes.number
          })
        )
    }).isRequired,
    quotationJourney: PropTypes.any,
    returnFlight: PropTypes.any,
    isPointsPlusMoneyDeparture: PropTypes.bool,
    isPointsPlusMoneyReturn: PropTypes.bool
}

const defaultProps = {
    returnFlight: null,
  };

class PaymentInformations extends React.Component {
    constructor(props) {
      super(props);

      let totalPoints = this.props.quotationJourney.values.totalPoints;
      let totalValueWithTaxs = this.props.quotationJourney.values.totalTaxesAndMoney;
      let returnFlightPrices;
        

      if (this.props.quotationJourney.returnFlight) {
        this.props.isPointsPlusMoneyReturn ? 
          returnFlightPrices = this.buildPassengersPoints(
            this.props.passengers,
            this.props.quotationJourney.returnFlight,
            true
          )
          :
          returnFlightPrices = this.buildPassengersPoints(
              this.props.passengers,
              this.props.quotationJourney.returnFlight,
              false
          );
        }
  
      if (this.props.isPointsPlusMoneyDeparture) {
        this.state = {
          departureFlightPrices: this.buildPassengersPoints(
              this.props.passengers,
              this.props.quotationJourney.departureFlight,
              true
            ),
          returnFlightPrices: returnFlightPrices,
          totalPoints: totalPoints,
          totalValueWithTaxs: totalValueWithTaxs
          }
        } 
          
      this.state = {
        departureFlightPrices: this.buildPassengersPoints(
          this.props.passengers,
          this.props.quotationJourney.departureFlight,
          false
        ),
        returnFlightPrices: returnFlightPrices,
        totalPoints: totalPoints,
        totalValueWithTaxs: totalValueWithTaxs
        };
        
    };

    buildPassengersPoints(passengersList, flight, isPointsPlusMoney) {
      let pointsPerPassenger = [];

      let i;
        for (i = 0; i < passengersList.length; i++) {
          let passenger = passengersList[i];
          let pointsPassenger = this.getPoints(passenger, flight, isPointsPlusMoney);
          pointsPerPassenger.push(this.getNameAndPoints(passenger, pointsPassenger));
        }
    
        return pointsPerPassenger;
    }

    getNameAndPoints(passenger, pointsPassenger) {
        return {
            completeName: `${passenger.name} ${passenger.lastName} ${passenger.suffix != undefined || passenger.suffix != null ? ' ' + passenger.suffix : ''}`,
            points: pointsPassenger
        };
    }

    getPoints(passenger, flight, isPointsPlusMoney) {
      let value;
      if (isPointsPlusMoney) {
        switch(passenger.passengerType) {
          case "ADT":
            value = flight.rangePointsPlusMoney.points;
            break;
          case "CH":
            value = flight.childPointsPlusMoney.points;
            break;
          case "IN":
            value = flight.infantPointsPlusMoney.points;
            break;
          default:
            value = null;
            break;
        }
      } else {
        switch(passenger.passengerType) {
          case "ADT":
            value = flight.value;
            break;
          case "CH":
            value = flight.childValue;
            break;
          case "IN":
            value = flight.infantValue;
            break;
          default:
            value = null;
            break;
        }
      }

      return value;
    }
    
    getPointsFormatted(value) {
        const pattern = /\B(?=(\d{3})+(?!\d))/g;
        return value.toString().replace(pattern, '.');
    }
    
    getValueFormatted(value) {
        return value
          .toFixed(2)
          .replace('.', ',')
          .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
    }
    
    renderPricePerPassengerFlight(departureFlight, isDeparture) {
        if (departureFlight) {
          return (
            <PointsPerPassengerList
              isDepartureFlight={isDeparture}
              origin={departureFlight.flight.originAirport}
              destination={departureFlight.flight.finalDestination}
              passengers={
                isDeparture ? this.state.departureFlightPrices : this.state.returnFlightPrices
              }
            />
          );
        }
    }

    render() {
        return (
            <div id={`PaymentData--${this.props.id}`} className="PaymentData">

                <Row className="PaymentData__passengerListInformation PaymentInformationPassengerList">
                    <Col className="departureInformation">
                      {this.renderPricePerPassengerFlight(this.props.quotationJourney.departureFlight, true)}
                    </Col>
                    <Col className="returnInformation">
                      {this.renderPricePerPassengerFlight(this.props.returnFlight, false)}
                    </Col>
                </Row>

                <Row className="PaymentData__information PaymentData__totalInPoints">
                  <Col xs={12} className="PaymentData__information--label">
                    {I18n.translate('components.paymentData.totalPoints')}
                  </Col>
                  <Col xs={12} className="PaymentData__information--pointsValue">
                    {I18n.translate('components.paymentData.valueInPts', {
                      value: <span>{this.getPointsFormatted(this.state.totalPoints)}</span>,
                      cipher: (
                        <span className="PaymentData__information--pointsValue--pts">
                          {I18n.translate('components.paymentData.ptsCipher')}
                        </span>
                      )
                    })}
                  </Col>
                </Row>

                <Row className="PaymentData__information PaymentData__totalInTax">
                  <Col xsHidden xs={12} className="PaymentData__information--textAlign">
                    {I18n.translate('components.paymentData.totalTaxAndMoney')}
                  </Col>
                  <Col
                    xsHidden
                    xs={12}
                    className="PaymentData__information--cipherValue PaymentData__information--taxValueDesktop">
                    {I18n.translate('components.paymentData.valueInBrl', {
                      value:  (
                        <span className="PaymentData__information__totalInMoney">
                          {this.getValueFormatted(this.state.totalValueWithTaxs)}
                        </span>
                      ),
                      cipher: (
                        <span className="PaymentData__information--cipherValue--cipher">
                          {I18n.translate('components.paymentData.BRLCipher')}
                        </span>
                      )
                    })}
                  </Col>
                </Row>
            </div>
        )
    }
}


PaymentInformations.propTypes = propTypes;
PaymentInformations.defaultProps = defaultProps;

export default PaymentInformations;


// WEBPACK FOOTER //
// ./src/page/checkout/components/PaymentInformation/PaymentInformations.jsx